import request from '@/utils/request'

// 获取首页轮播图
export function getBanner() {
  return request({
    url: 'app/home/getBanner',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js